import {
  Component, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, HostListener, Inject,
  NgZone, OnInit, OnDestroy, QueryList, ViewChild, ViewChildren, HostBinding,
} from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription ,  Observable ,  BehaviorSubject } from 'rxjs';


import * as moment from 'moment';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { publishedToast } from 'shared/toaster/toasts';
import { itemWasUpdatedToast } from 'shared/toaster/toasts';

import { segments } from './segments-list';
import { SegmentsParams } from 'shared/segments-navigation/segments-navigation/segments-navigation-params.interface';
import segmentsAsyncs from './segments-asyncs';
import { getAssetThumbnail, isImageFileType } from 'shared/digital-assets/digital-asset-helpers';
import { rightPanelNavs } from './right-panel-navs';
import { SideNavButtonModel } from 'shared/status-sidenav/status-sidenav/side-nav.model';
import { Config } from 'shared/config/env.config';
import { indexPagesData } from 'utils/index-pages-data';
import { getFieldByMap, getItemProperty } from 'utils/utils';
import { headerHeight, navPanelHeight } from '../variables';
import { getDamHintsDefaultHTML } from './hints-default-html';
import { setItemDetailValidation } from 'shared/item-detail/item-detail-validation';
import { setUnreadCommentsCount } from 'shared/comments/comments-helpers';

import { BaseRoutingPageComponent } from 'shared/base/_base-routing-page.component';
import { SegmentsNavigationComponent } from 'shared/segments-navigation/segments-navigation/segments-navigation.component';
import { StickyComponent } from 'shared/sticky/sticky.component';
import { DigitalAssetsPanelComponent } from '../digital-assets-panel/digital-assets-panel.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';
import { LoaderComponent } from 'shared/loader/loader.component';

import { BrandService } from 'shared/brand/brand.service';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { DigitalAssetDetailsService } from './digital-asset-details.service';
import { DigitalAssetsService } from 'shared/digital-assets/digital-assets.service';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { StickyService } from 'shared/sticky/sticky.service';
import { AppRoutingService } from '../app-routing.service';
import { SessionService } from 'shared/session/session.service';
import { HintsService } from 'shared/hints/hints.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { ReturnRouteModel } from 'shared/return-route/return-route.model';
import { ReturnRouteService } from 'shared/return-route/return-route.service';
import { CommentsService } from 'shared/comments/comments.service';
import { PreferencesService } from 'shared/preferences/preferences.service';

import { ConvertUTCToTZPipe } from 'shared/pipes/convert-utc-to-tz.pipe';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {finalize, takeWhile} from 'rxjs/operators';
import {merge} from 'rxjs';
import {ProductPanelComponent} from '../product-panel/product-panel.component';
import {UntypedFormGroup} from '@angular/forms';


@Component({
  moduleId: module.id,
  selector: 'sd-digital-asset-details',
  templateUrl: 'digital-asset-details.component.html',
  styleUrls: ['digital-asset-details.component.scss'],
  providers: [StickyService, ScrollToService, HintsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalAssetDetailsComponent extends BaseRoutingPageComponent implements OnInit, OnDestroy {

  assetDetail: any = {};
  uiModel: any = {};
  model: any = {};
  segmentsNavigationData: SegmentsParams = {
    segments: segments,
    sideNavSize: 100,
    marginLeft: 35,
  };
  segmentsAsyncs: any = segmentsAsyncs;
  isScrollingTo: boolean = false;
  rightPanelNavs: any[] = rightPanelNavs;
  imageHintFields: Array<string> = [
    'file_type',
    'filesize',
    'color_mode',
    'resolution',
  ];
  fileHintFields: Array<string> = [
    'file_type',
    'filesize',
  ];

  item: string = '';
  paddingBottom: number = 0;
  sideNavStatus: string = '';
  sideNavTopButton: SideNavButtonModel = new SideNavButtonModel();
  sideNavBottomButton: SideNavButtonModel = new SideNavButtonModel();

  form: UntypedFormGroup;

  @HostBinding('class.details-page') detailsPageClass: boolean = true;

  @ViewChild(SegmentsNavigationComponent, {static: false}) segmentsNavigation: SegmentsNavigationComponent | void;

  @ViewChild(DigitalAssetsPanelComponent, {static: true}) digitalAssetPanel: DigitalAssetsPanelComponent | void;

  @ViewChild(DynamicNavsComponent, {static: true}) dynamicNavs: DynamicNavsComponent | void;

  @ViewChild('segmentsContent', {static: false}) segmentsContent: ElementRef | void;

  @ViewChildren('segmentItem') segmentItems: QueryList<ElementRef> | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent;

  private getAssetDetailSub: Subscription;
  private timezone: any;

  constructor(
    private scrollToService: ScrollToService,
    public digitalAssetsService: DigitalAssetsService,
    public pageService: DigitalAssetDetailsService,
    protected router: Router,
    private route: ActivatedRoute,
    private stickyService: StickyService,
    private location: Location,
    private brandService: BrandService,
    private segmentValidationService: SegmentValidationService,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    private appRoutingService: AppRoutingService,
    private toastrService: ToastrService,
    private sessionService: SessionService,
    private hintsService: HintsService,
    private commentsService: CommentsService,
    private preferencesService: PreferencesService,
    private convertUTCToTZPipe: ConvertUTCToTZPipe,
    protected permissionsService: PermissionsService,
    protected returnRouteService: ReturnRouteService,
  ) {
    super(router);
    ngZone.runOutsideAngular(() => {
      const source = fromEvent(window, 'scroll');
      source
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((e: any) => {
        this.stickyService.handleScrolling();
        if (this.uiModel.isHeaderMinimized && window.pageYOffset < 420) {
          this.uiModel.isHeaderMinSubject.next(false);
        }
        if (!this.uiModel.isHeaderMinimized && window.pageYOffset > 420) {
          this.uiModel.isHeaderMinSubject.next(true);
        }
      });
    });
    _.each(this.segmentsNavigationData.segments, (item: any, index: number) => {
      item.active = index === 0;
    });
  }

  get updatedDate(): string {
    if (!this.assetDetail || !_.get(this, 'assetDetail.updated_at')) {
      return '';
    }
    const dateTZ = this.convertUTCToTZPipe.transform(this.assetDetail.updated_at, this.timezone);
    return moment(dateTZ).format('MMMM Do, YYYY');
  }

  get lastPublishedDate(): string {
    if (!this.assetDetail || !_.get(this, 'assetDetail.last_published_date.date')) {
      return '';
    }
    const dateTZ = this.convertUTCToTZPipe.transform(this.assetDetail.last_published_date.date, this.timezone);
    return moment(dateTZ).format('MMMM Do, YYYY');
  }

  get description(): string {
    if (!this.assetDetail || !this.segmentsAsyncs) { return ''; }
    const field: any = getFieldByMap('des', segmentsAsyncs.description.value);
    const path = field ? field.item_name : '';
    const descr = getItemProperty(field, path, this.assetDetail);
    return descr.EN;
  }

  get imageUrl() {
    return this.assetDetail ? getAssetThumbnail(this.assetDetail, 'big') : '';
  }

  get imageThumbnailUrl() {
    return this.assetDetail ? getAssetThumbnail(this.assetDetail, 'small') : '';
  }

  get itemId(): any {
    return _.get(this.route.snapshot.params, 'id', '');
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get originId(): string|undefined {
    return _.get(this.assetDetail, 'origin_id');
  }

  @HostListener('window:resize', ['$event']) onResize() {
    this.updatePageSpace();
  }

  ngOnInit() {
    super.ngOnInit();
    this.uiModel = this.pageService.uiModel;
    this.model = this.pageService.model;
    this.scrollToService.init({
      pageScrollOffset: this.uiModel.headerMinHeight - this.uiModel.segmentItemOffsets
    });
    this._initStickyService();
    this.uiModel.isHeaderMinSubject
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((val: boolean) => {
      if (this.uiModel.isHeaderMinimized === this.uiModel.isHeaderMinSubject.getValue()) { return; }
      this.uiModel.isHeaderMinimized = val;
      this.ref.markForCheck();
    });
    if (this.digitalAssetPanel && this.digitalAssetPanel.panelModal) {
      this.digitalAssetPanel.panelModal.onHidden
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe(() => {
          this.ref.markForCheck();
        });
    }


    _.defer(() => {
      const tab = _.get(this.route.snapshot.params, 'tab');
      if (tab && this.dynamicNavs) { this.dynamicNavs.selectNav(tab); }
      // navs change event
      this.subscribeNavsChange();
    });

    // get timezone
    this.preferencesService.getPreferences()
    .subscribe((preferences: any) => {
      this.timezone = preferences.timezone;
    });

    // Angular 15: RouterOutlet instantiates the component after NavigationEnd fires,
    // so the constructor's router.events subscription misses the initial navigation.
    this.onRouteChange(null as any);
  }

  ngOnDestroy() {
    if (this.getAssetDetailSub) { this.getAssetDetailSub.unsubscribe(); }
    super.ngOnDestroy();
  }

  onRouteChange(event: NavigationEnd) {
    window.scrollTo(0, 0);
    const { segment, id } = this.route.snapshot.params;
    _.defer(() => {
      this.getAssetDetail(this.brandId, id)
      .then(() => {
        this.model.id = id;
        this.updatePageSpace();
        if (segment !== 'details') {
          this._scrollToSegment(segment);
          if (this.segmentsNavigation) {
            this.segmentsNavigation.setActive(segment);
          }
        }
        if (this.dynamicNavs && _.get(this.dynamicNavs.activeNav, 'name') === 'comments') {
          this.dynamicNavs.componentRef.instance.fetch(this.brandId, this.originId, 'asset');
        }
        this.ref.markForCheck();
      });
    });
  }

  onSelectSegment(segment: any) {
    const segmentName = segment.name;
    this._scrollToSegment(segmentName);
    this._setLocationUrl(segmentName);
    this._setSegmentName(segmentName);
  }

  onOpenPanel() {
    this.openPanel();
  }

  onClosePanel() {
    this.getAssetDetail(this.brandId, this.model.id);
    this.updatePageSpace();
  }

  onImageClick($event: MouseEvent) {
    $event.stopPropagation();
    if (this.assetDetail.download_link) {
      window.open(this.assetDetail.download_link, '_blank');
    }
  }

  onDetailsPageClose() {
    this.closePage();
  }

  getAssetDetail(brand: string, id: string): Promise<any> {
    return new Promise<void>(resolve => {
      this.getAssetDetailSub = this.digitalAssetsService.getAssetDetails(brand, id)
      .subscribe((assetDetail: any) => {
        assetDetail.validation = _.pick(assetDetail.validation, Config.VALIDATION_TYPES);
        this.assetDetail = setItemDetailValidation(assetDetail);

        let validation = this.segmentValidationService.formatValidationTypes(assetDetail.validation);

        // PIES 6.7 validation row was added for test
        const pies65 = _.find(validation, {key: 'pies65'});
        if (pies65) {
          validation = [...validation, {
            key: 'pies67',
            title: 'PIES 6.7',
            valid: pies65.valid,
          }];
        }
        this.updateSegmentsValidation();

        this.segmentValidationService.setData(validation);

        this.populateSideNavValues(assetDetail.assigned);

        // add hints table to the right panel
        _.defer(() => {
          const html = getDamHintsDefaultHTML(
            assetDetail,
            isImageFileType(assetDetail) ? this.imageHintFields : this.fileHintFields
          );
          this.hintsService.setDefaultHintText(html);
        });

        this.setUnreadCommentsCount();

        _.delay(() => {
          resolve();
        }, 1000);
      });
    });
  }

  updatePageSpace() {
    const pageViewportHeight = window.innerHeight - headerHeight - navPanelHeight;
    const lastSegmentHeight = this.segmentItems && this.segmentItems.last.nativeElement.getBoundingClientRect().height || 0;

    if (lastSegmentHeight < pageViewportHeight) {
      // if last segment height is less than viewport height -
      // add padding for ability to scroll to this segment
      this.paddingBottom = pageViewportHeight - lastSegmentHeight + 10;
    }
  }

  onSideNavButtonClicked(value: any) {
    if (this.loader) {
      this.loader.show();
    }
    this.digitalAssetsService.postUpdateStatus(this.brandId, this.assetDetail._id, value)
      .subscribe( (assetDetail) => {
        this.assetDetail = setItemDetailValidation(assetDetail);
        this.populateSideNavValues(this.assetDetail.assigned);
        if (value === 8) {
          this.toastrService.info('', '', publishedToast('asset'));
        }
        if (this.loader) {
          this.loader.hide();
        }
        this.ref.markForCheck();
      });
  }

  populateSideNavValues(assigned: number) {
    if (assigned === 1) { // Assigned
      this.sideNavStatus = 'Assigned';
      this.sideNavTopButton.show = false;

      this.sideNavBottomButton.text = 'Publish';
      this.sideNavBottomButton.show = this.hasPermission(['admin', 'dam-edit']);
      this.sideNavBottomButton.value = 8;
      this.sideNavBottomButton.hoverClass = 'hover-gold';
    } else if (assigned === 0) { // unassigned
      this.sideNavStatus = 'Unassigned';
      this.sideNavTopButton.show = false;
      this.sideNavBottomButton.show = false;
    } else if (assigned === 3) { // not uploaded
      this.sideNavStatus = 'Not uploaded';
      this.sideNavTopButton.show = false;
      this.sideNavBottomButton.show = false;
    }
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  private getPrevPage(prevRoute: string): any {
    const splittedRoute = prevRoute.split('/');
    let page = splittedRoute.length > 1 ? splittedRoute[2] : null;
    if (!page) {
      page = _.get(JSON.parse(localStorage.getItem('myProductsSearchModel')), 'route', '');
    }
    return page;
  }

  private get _rootUrl(): string {
    const url = this.route.snapshot.url;
    return url[0].path + '/' + url[1].path;
  }

  private _initStickyService() {
    this.stickyService.init(this.uiModel.headerMinHeight + this.uiModel.segmentItemOffsets , 'sticky', this.segmentsContent);
    this.stickyService.stickEvent
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((item: StickyComponent) => {
      if (this.isScrollingTo) {
        this.isScrollingTo = false;
        return;
      }
      if (this.segmentsNavigation) {
        this.segmentsNavigation.setActive(item.name);
      }
      this.ref.markForCheck();
      this._setLocationUrl(item.name);
    });
  }

  private _setLocationUrl(segmentName: string): void {
    this.location.go(this._rootUrl + '/' + segmentName);
  }

  private _scrollToSegment(segment: string): void {
    this.isScrollingTo = true;
    this.scrollToService.scrollTo({scrollTarget: `#${segment}`});
  }

  private _setSegmentName(segmentName: string): void {
    this.model.segment = segmentName;
  }

  private openPanel() {
    if (this.digitalAssetPanel) {
      this.digitalAssetPanel.show();
    }
  }

  private updateSegmentsValidation() {
    if (this.segmentsNavigation) {
      this.segmentsNavigation.toggleCircles((segment: any) => {
        return this.assetDetail.validation.segmentErrors.indexOf(segment.segment) > -1;
      });
    }
  }

  private subscribeNavsChange() {
    if (this.dynamicNavs) {
      this.dynamicNavs.changeNav
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe((obj: any) => {
          if (obj.nav.name === 'comments') {
            if (this.originId) {
              obj.componentRef.instance.fetch(this.brandId, this.originId, 'asset');
            }
            merge(
              obj.componentRef.instance.commentMarkedAsRead,
              obj.componentRef.instance.commentResolved
            )
              .pipe(takeWhile(() => obj.componentRef.instance.isActive))
              .subscribe(() => {
                this.setUnreadCommentsCount();
              });
          }
        });
    }
  }

  private setUnreadCommentsCount(): void {
    this.commentsService.getUnreadCount(this.brandId, 'asset', this.originId)
    .subscribe((data: any) => {
      setUnreadCommentsCount(this.rightPanelNavs, data.count);
      this.ref.markForCheck();
    });
  }

  private closePage() {
    const defaultRoute = '/digital-assets';
    const returnRoute = new ReturnRouteModel(defaultRoute, {smlocal: 1});
    this.router.navigate([returnRoute.route], { queryParams: returnRoute.queryParams } );
  }

  onSaveClick($event) {
    this.loader.show();
    this.digitalAssetsService.putAssets(this.brandId, this.itemId, $event)
      .pipe(finalize(() => this.loader.hide()))
      .subscribe(() => {
        this.loader.hide();
        this.getAssetDetail(this.brandId, this.model.id);
      });
  }
}
